import { Controller } from 'stimulus';

export default class extends Controller {
  addToUrl({ currentTarget, params: { url } }) {
    const target = new URL(url, window.location.origin);

    this.#selectedIds().forEach((id) => target.searchParams.append('ids[]', id));
    currentTarget.setAttribute('data-ui--twin-turbo-modal-trigger-url-value', target);
  }

  #selectedIds() {
    const ids = new URLSearchParams(window.location.search).get('ids') || '';

    return ids.split(',').filter(Boolean);
  }
}
